import axios from "axios";
import Config from "../utils/Config";
const BASE_URL = `${Config.apiUrl}`;

class GeneralService {
  getHeaders(){
    const token = localStorage.getItem("token") || "";
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  }

  async validateAgentReferralCode(agent_code){
    try{
      const response = await axios.get(
        `${BASE_URL}/user/validate/agent/${agent_code}`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data.reason || "Agent code validated successfully",
      }
    }catch(error){
      return {
        status: false,
        data: null,
        message: error.response?.data?.data?.reason || "An error occurred while validating agent code",
      }
    }
  }
}
const generalService = new GeneralService();
export default generalService;